import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './CompleteProfile.css';

/**
 * Shown when a user is authenticated but hasn't finished setup
 * (e.g. they arrived via a magic link instead of the OTP code flow).
 * Forces them to set name, company, and a password before entering the app.
 */
export default function CompleteProfile() {
  const { user, supabase, signOut } = useAuth();
  const meta = user?.user_metadata || {};

  const [name, setName]       = useState(meta.name || '');
  const [company, setCompany] = useState(meta.company || '');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [busy, setBusy]         = useState(false);
  const [error, setError]       = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim())            return setError('Please enter your name.');
    if (password.length < 6)     return setError('Password must be at least 6 characters.');
    if (password !== confirm)    return setError('Passwords do not match.');
    setBusy(true); setError('');
    const { error } = await supabase.auth.updateUser({
      password,
      data: { name, company, profile_complete: true },
    });
    setBusy(false);
    if (error) return setError(error.message);
    // onAuthStateChange fires USER_UPDATED → AppInner re-renders into the app.
  };

  return (
    <div className="cp-page">
      <div className="cp-card">
        <img src="/axion-logo.png" alt="Axion Mobility" className="cp-logo" />
        <h2>Complete Your Account</h2>
        <p className="cp-lead">
          You're signed in as <strong>{user?.email}</strong>. Finish setting up your account to continue.
        </p>
        {error && <div className="cp-error">{error}</div>}
        <form onSubmit={submit}>
          <input type="text" placeholder="Full name" value={name}
            onChange={e => setName(e.target.value)} required autoFocus />
          <input type="text" placeholder="Company name (optional)" value={company}
            onChange={e => setCompany(e.target.value)} />
          <input type="password" placeholder="Create a password (min 6 chars)" value={password}
            onChange={e => setPassword(e.target.value)} required />
          <input type="password" placeholder="Confirm password" value={confirm}
            onChange={e => setConfirm(e.target.value)} required />
          <button type="submit" className="cp-submit" disabled={busy}>
            {busy ? 'Saving…' : 'Create Account & Continue'}
          </button>
        </form>
        <p className="cp-signout" onClick={signOut}>Sign out</p>
      </div>
    </div>
  );
}
